import { StreamedArtifactSidePanel } from './StreamedArtifactSidePanel';
import type { MessageArtifact } from '@ideoz/core';

interface ArtifactPanelOverlayProps {
  artifact: MessageArtifact;
  onClose: () => void;
  onSave: (content: string) => Promise<void>;
  onSaveStructured: (json: Record<string, unknown>) => Promise<void>;
  onShare: () => Promise<void>;
}

/** Dumb: right-side drawer overlay wrapping the shared artifact panel. */
export function ArtifactPanelOverlay({
  artifact,
  onClose,
  onSave,
  onSaveStructured,
  onShare,
}: ArtifactPanelOverlayProps): JSX.Element {
  return (
    <div className="fixed inset-0 z-40 flex justify-end bg-black/30" onClick={onClose}>
      <div className="w-full max-w-3xl h-full" onClick={(e) => e.stopPropagation()}>
        <StreamedArtifactSidePanel
          artifact={artifact}
          isOpen
          onClose={onClose}
          onSave={artifact.id ? onSave : undefined}
          onSaveStructured={artifact.id ? onSaveStructured : undefined}
          onShare={artifact.id ? onShare : undefined}
        />
      </div>
    </div>
  );
}
